module.exports = __webpack_public_path__ + "img/perl-icon.fa751e4b.png";